import { FC } from 'react';

import { CellProps } from 'react-table';

import { PatientListTableRow } from 'views/Pages/PatientList/PatientList.types';

export const PatientListTableCell: FC<CellProps<PatientListTableRow>> = (cellProps) => (
  <>{cellProps.value || '-'}</>
);
